module.exports = __webpack_public_path__ + "img/ban-white.9f5a6e10.svg";